import { TOnboardingInitialState } from "./onboarding.types";

export const initialState: TOnboardingInitialState = {
  isActive: false,
};
